import { InputField } from '@components/forms/InputField'

interface CampaignSettingFormProps {
  viewMode?: boolean
}

export function CampaignSettingForm({ viewMode }: CampaignSettingFormProps) {
  return (
    <div className='border rounded-[12px] p-[30px] mb-[20px]'>
      <p className='text-[18px] font-medium font-mitr text-secondary mb-[20px]'>
        รายละเอียดแคมเปญ
      </p>
      <div className='flex flex-col gap-y-[20px]'>
        <InputField
          name='name'
          label='ชื่อแคมเปญ'
          placeholder='ระบุชื่อแคมเปญ'
          disabled={viewMode}
        />
      </div>
    </div>
  )
}
